import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface SnackbarData {
  message: string;
  details?: string;
  icon?: string;
  panelClass?: string;
  /** Raw value to expose a copy-to-clipboard button (e.g. the member's QC code) */
  copyValue?: string;
}

@Component({
  selector: 'dragonfly-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  standalone: false,
})
export class NotificationsComponent {
  copied = false;
  private copyTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    public snackBarRef: MatSnackBarRef<NotificationsComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData | string,
    private clipboard: Clipboard,
  ) {}

  get isRich(): boolean {
    return typeof this.data === 'object' && this.data !== null;
  }

  get richData(): SnackbarData {
    return this.data as SnackbarData;
  }

  get plainMessage(): string {
    return this.data as string;
  }

  copy(): void {
    if (!this.richData.copyValue) return;
    this.clipboard.copy(this.richData.copyValue);
    this.copied = true;
    if (this.copyTimer) clearTimeout(this.copyTimer);
    this.copyTimer = setTimeout(() => (this.copied = false), 2000);
  }
}
